import type { useToast } from "@/components/ui/use-toast";
import { formatErrorMessage } from "@/utils/format";

export type ApiResponseWithError = {
  response?: {
    status: number;
  };
  error?: {
    message?: string;
  };
};
/*
* This function is used to handle API errors.
* Deprecated: Handle in place with the new client.
*/
export const handleApiError = (
  result: ApiResponseWithError | undefined,
  toast: ReturnType<typeof useToast>["toast"],
  successMessage?: string
): boolean => {
  if (!result || result?.response?.status !== 200) {
    toast({
      title: "Uh oh!",
      description: result?.error?.message
        ? formatErrorMessage(result.error.message)
        : "An error occurred while processing your request. " + JSON.stringify(result),
      variant: "destructive",
    });
    return false;
  }

  if (successMessage) {
    toast({
      description: successMessage,
    });
  }

  return true;
};
